import React from "react";
import { Fab } from "@mui/material";
import { builder } from "Classes/global";
import { Robot } from "Classes/Robot";
import { useTypedDispatch, useTypedSelector } from "hooks/store";
import {
    BsuAvailableColorType,
    updateSelectedBsuColor,
    updateSelectedPortConnection,
} from "state/slices/SceneSlice";
import { Inventory } from "Classes/InventoryService";
import { CurrentDrawerOpenType, updateDrawerTitle } from "state/slices/RightDrawerSlice";
import { StaticMesh } from "Classes/StaticMesh";

interface ComponentProps {
    currentColor: BsuAvailableColorType;
    portSelected?: boolean;
}

const BSUColorItemComponent = ({
    currentColor,
    portSelected,
}: ComponentProps): JSX.Element | null => {
    const dispatch = useTypedDispatch();
    const selectedBsu = useTypedSelector((store) => store.Scene.selectedBSU);
    const drawerOpenType = useTypedSelector((store) => store.ModelWindow.type);
    const selectedPort = useTypedSelector((store) => store.Scene.selectedPort);

    const isActive = (): string => {
        if (portSelected) {
            if (selectedPort && selectedPort.color === currentColor.name) {
                return "active";
            } else {
                return "";
            }
        }
        if (selectedBsu && currentColor.name === selectedBsu.id) {
            return "active";
        }
        return "";
    };
    const isDisable = (): boolean => {
        // If store drawer open type is port, then isDisable  will false everytime.
        if (drawerOpenType === CurrentDrawerOpenType.Port) {
            return false;
        }

        // Check is active, if it is then do not disable.
        if (selectedBsu && currentColor.name === selectedBsu.id) {
            return false;
        }

        if (Inventory.colors[currentColor.name].isUsed) {
            return true;
        }
        return false;
    };
    const handleColorUpdate = (): void => {
        switch (drawerOpenType) {
            case CurrentDrawerOpenType.BSUObject:
                dispatch(updateSelectedBsuColor(currentColor.name));
                // Update CMR.
                (builder.room.selectedObject as Robot).setLight({
                    name: currentColor.name,
                    hexColor: currentColor.color,
                });
                break;
            case CurrentDrawerOpenType.Port:
                dispatch(updateDrawerTitle(`Port - ${currentColor.name}`));
                dispatch(updateSelectedPortConnection(currentColor.name));
                const currentSelectedPort = (builder.room.selectedObject as StaticMesh).name;
                builder.room.linkPortToBsu(currentColor.name, currentSelectedPort);
        }
    };

    const showBsuColor = (): boolean => {
        if (selectedBsu && currentColor.name === selectedBsu.id) {
            return true;
        }
        if (!Inventory.colors[currentColor.name].isUsed) {
            return true;
        }
        return false;
    };

    if (drawerOpenType === CurrentDrawerOpenType.BSUObject) {
        if (showBsuColor()) {
            return (
                <Fab
                    onClick={() => handleColorUpdate()}
                    disabled={isDisable()}
                    className={`btnColor ${isActive()} ${isDisable() ? "disabled" : ""}`}
                    style={{
                        borderColor:
                            currentColor.name === "white" && isActive() !== "active"
                                ? "#ccc"
                                : currentColor.color,
                        backgroundColor: currentColor.color,
                    }}
                    sx={[
                        {
                            "&:hover": {
                                borderColor: `#000 !important`,
                            },
                        },
                    ]}
                />
            );
        }
        return null;
    }

    return (
        <>
            <Fab
                onClick={() => handleColorUpdate()}
                disabled={isDisable()}
                className={`btnColor ${isActive()} ${isDisable() ? "disabled" : ""}`}
                style={{
                    borderColor:
                        currentColor.name === "white" && isActive() !== "active"
                            ? "#ccc"
                            : currentColor.color,
                    backgroundColor: currentColor.color,
                }}
                sx={[
                    {
                        "&:hover": {
                            borderColor: `#000 !important`,
                        },
                    },
                ]}
            />
        </>
    );
};

export default BSUColorItemComponent;
